// @ts-nocheck
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import DropdownMenuItem from '../models/DropdownMenuItem';
import { PhaseSortTypes } from '../models/SortTypes';

interface ISortMenuProps {
  menuItems: Array<DropdownMenuItem>;
  onChange: (value: number) => void;
  anchorEl: Element | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<any>>;
}

const DropDownMenu = React.memo(
  ({ menuItems, onChange, anchorEl, setAnchorEl }: ISortMenuProps) => {
    const onClick = (value: PhaseSortTypes) => {
      onChange(value);
      setAnchorEl(null);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const items = menuItems.map((item) => (
      <MenuItem
        key={item.value}
        className={`${item.additionalCssClass}`}
        value={item.value}
        disabled={item.isDisabled === true}
        onClick={() => onClick(item.value)}
      >
        {item.name}
      </MenuItem>
    ));

    return (
      <Menu
        disableRestoreFocus={true}
        onClose={handleClose}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
      >
        {items}
      </Menu>
    );
  }
);

export default DropDownMenu;
